import "../styles/About.css";

const OBITUARIES = [
  {
    id: "arabic-lebanon",
    language: "Arabic for Lebanon",
    nativeLanguage: "النعي باللغة العربية - لبنان",
    description: "Obituary and funeral arrangements in Lebanon",
    href: "/media/obituary/father-paul-oneid-obituary-arabic-lebanon.pdf",
    thumbnail: "/media/obituary/father-paul-oneid-obituary-arabic-lebanon-thumbnail.jpg",
    alt: "Arabic obituary for Father Paul Oneid for Lebanon",
    direction: "rtl",
  },
  {
    id: "english-canada",
    language: "English for Canada",
    nativeLanguage: "English - Canada",
    description: "Obituary and funeral arrangements in Canada",
    href: "/media/obituary/father-paul-oneid-obituary-english.pdf",
    thumbnail: "/media/obituary/father-paul-oneid-obituary-english-thumbnail.jpg",
    alt: "English obituary for Father Paul Oneid for Canada",
  },
  {
    id: "arabic-canada",
    language: "Arabic for Canada",
    nativeLanguage: "النعي باللغة العربية - كندا",
    description: "Obituary and funeral arrangements in Canada",
    href: "/media/obituary/father-paul-oneid-obituary-arabic.pdf",
    thumbnail: "/media/obituary/father-paul-oneid-obituary-arabic-thumbnail.jpg",
    alt: "Arabic obituary for Father Paul Oneid for Canada",
    direction: "rtl",
  },
];

export default function About() {
  return (
    <section className="obituary" role="main" aria-labelledby="obituary-title">
      <header className="obituary__header">
        <h1 id="obituary-title">Obituary</h1>
        <p className="obituary__language-prompt">Choose a language · اختر اللغة</p>
      </header>
      <div className="obituary__languages">
        {OBITUARIES.map((obituary) => (
          <a
            className="obituary__language-card"
            href={obituary.href}
            target="_blank"
            rel="noreferrer"
            aria-label={`Open the ${obituary.language} obituary in a new tab`}
            key={obituary.id}
          >
            <span className="obituary__thumbnail-wrap">
              <img
                className="obituary__thumbnail"
                src={obituary.thumbnail}
                alt={obituary.alt}
              />
            </span>
            <span
              className="obituary__language-name"
              dir={obituary.direction}
              lang={obituary.direction ? "ar" : "en"}
            >
              {obituary.nativeLanguage}
            </span>
            {obituary.description && (
              <span className="obituary__language-description">
                {obituary.description}
              </span>
            )}
            <span className="obituary__open-label">
              {obituary.direction === "rtl" ? "فتح المستند" : "Open document"}
            </span>
          </a>
        ))}
      </div>
      <p className="obituary__hint">Select a thumbnail to open the full-size document.</p>
    </section>
  );
}
